export const CREATE_QUEUER = 'CREATE_QUEUER';

export const createQueuer = queuer => ({
  type: CREATE_QUEUER,
  queuer,
});
